export const MEMBERSHIP_API = '/api/membership'
